export default __webpack_public_path__ + "resources/icons/d200-aa8b.png";